/* Product-card gallery: arrow clicks (desktop) + swipe (mobile) through up to
   3 images per card, with dot state. Delegated so it works for cards injected
   later (load-more, section rerenders). */
(function () {
  function step(gal, delta) {
    gal.classList.add('card-gal--manual'); // manual nav wins over hover preview
    var imgs = gal.querySelectorAll('.media img.card-gal__img');
    if (imgs.length < 2) return;
    var active = 0;
    imgs.forEach(function (img, i) {
      if (img.classList.contains('is-active')) active = i;
    });
    var next = (active + delta + imgs.length) % imgs.length;
    imgs.forEach(function (img, i) {
      img.classList.toggle('is-active', i === next);
    });
    var dots = gal.querySelectorAll('.card-gal__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === next);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-gal-prev], [data-gal-next]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      step(btn.closest('.card-gal'), btn.hasAttribute('data-gal-next') ? 1 : -1);
    },
    true
  );

  var touch = { gal: null, x: 0, y: 0, swiped: false };
  document.addEventListener(
    'touchstart',
    function (e) {
      var gal = e.target.closest('.card-gal');
      touch.gal = gal;
      touch.swiped = false;
      if (!gal) return;
      touch.x = e.touches[0].clientX;
      touch.y = e.touches[0].clientY;
    },
    { passive: true }
  );
  document.addEventListener(
    'touchend',
    function (e) {
      if (!touch.gal) return;
      var dx = e.changedTouches[0].clientX - touch.x;
      var dy = e.changedTouches[0].clientY - touch.y;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        touch.swiped = true;
        step(touch.gal, dx < 0 ? 1 : -1);
      }
    },
    { passive: true }
  );
  // a swipe must not follow the card link
  document.addEventListener(
    'click',
    function (e) {
      if (touch.swiped && e.target.closest('.card-gal')) {
        e.preventDefault();
        e.stopPropagation();
        touch.swiped = false;
      }
    },
    true
  );

  // the gallery layer sits above the card's stretched link, so plain image
  // clicks navigate to the product explicitly (controls excluded)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gal-prev], [data-gal-next], .card-add-chip, .card-gal__dots, .cqp-panel')) return;
    if (!e.target.closest('.card-gal .media')) return;
    var card = e.target.closest('.card-wrapper, .card');
    var link = card && card.querySelector('.card__heading a, a.full-unstyled-link');
    if (link && link.href) {
      e.preventDefault();
      window.location.href = link.href;
    }
  });
})();
